import { render, staticRenderFns } from "./upShopHouseInManage.vue?vue&type=template&id=968b27cc&scoped=true"
import script from "./upShopHouseInManage.vue?vue&type=script&lang=js"
export * from "./upShopHouseInManage.vue?vue&type=script&lang=js"
import style0 from "./upShopHouseInManage.vue?vue&type=style&index=0&id=968b27cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968b27cc",
  null
  
)

export default component.exports